var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm.$timeAgo(_vm.date)))])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.$formatDate(_vm.date, "d MMMM y, H:mm"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }